import gql from "graphql-tag";

export const myCertifiedFragment = gql`fragment mycertifiedplant on MyCertifiedPlant {
  users {
      userLevel
      email
    }
    plantId
    loggers {
      loggerId
      devices {
        sn
        dsps
        dspm
        arm
        fota_status
        lastUpdate
      }
      inverter {
        sn
        arm
        dspm
        dsps
        fota_module
        fota_status
        updating
        lastUpdate
        upd_global {
          status
          progress
          createdAt
        }
      }
      lan {
        eth_DNS
        wifi_status
        wifi_routerIP
        wifi_psw
        wifi_online
        wifi_ip
        wifi_enabled
        wifi_DNS
        wifi_SSID
        lte_strength
        lte_apnUser
        lte_apnServer
        lte_apnPsw
        lte_IMSI
        lte_IMEI
        lte_ICCID
        eth_status
        eth_routerIP
        eth_online
        eth_ip
        eth_enabled
      }
      info {
        name {
          timestamp
          name
        }
        hwv {
          timestamp
          hwVer
        }
        fw {
          sn
          model
          manufacturer
          hardwareVer
          firmwareVer
          cfgFileVer
          cfgFileName
        }
        def {
          type
          timestamp
          thingDef
        }
        connection {
          timestamp
          status
          ipAddress
          disconnectReason
        }
      }
      devices {
        sn
        dsps
        dspm
        arm
        fota_status
      }
    }
    geo {
      IANA
      latitude
      longitude
    }
    ems_state {
      loggerId
      io {
        var1
        time_tl1
        time_tl
        time_th1
        time_th
        thL1
        thL
        thH1
        thH
        templateId
        t_min
        t6_stop
        t6_start
        t5_stop
        t5_start
        t4_stop
        t4_start
        t3_stop
        t3_start
        t2_stop
        t2_start
        t1_stop
        t1_start
        t0_stop
        t0_start
        state
        src
        out_state
        out1
        name
        n_out
        level
        index
        function
        description
        d_stop
        d_start
        active
      }
      info {
        sn {
          updatedAt
          uid
          type
          timestamp
          createdAt
          sn
        }
        hwv {
          timestamp
          hwVer
        }
        name {
          timestamp
          name
        }
        def {
          type
          timestamp
          thingDef
        }
        fw {
          updatedAt
          type
          timestamp
          fw_ver
          fwCategory
          fota_status
          createdAt
        }
        connection {
          timestamp
          status
          ipAddress
          disconnectReason
        }
        cell_info {
          updatedAt
          imei
          icc_id
          cell_serial
          cell_revision
          cell_model
        }
      }
      evch {
        wb_err_ts
        wb_err_id
        updatedAt
        type
        tpPower
        tpDuration
        timestamp
        tStart
        status
        startTime
        st_cmd
        sn
        rt_exp
        rsn
        ready
        model
        maxpw
        limitPower
        inputGreenPower
        fwVer
        error_ts
        error_id
        createdAt
        chargerMode
        carConsumption
        active
      }
      devices {
        version
        type
        timestamp
        threeF
        thingDef
        sn
        sensor_mode
        registered
        model
        modbus_address
        k
        id
        fw_rev
        grid_meter
        dsps
        dspm
        d2evc
        arm
        active
      }
      config {
        timestamp
        ta_sign
        sensor_mode
        plantCurrSensTR
        plantCurrSensO
        pext
        pType
        net
        mt_sign
        maxLoadPwr
        latitude
        longitude
        io_ing_used
        io_out_used
        invCurrSensTR
        io_cnt_func
        ext_device
        error_ts
        invCurrSensO
        error_id
        connection
        configVerified
        TZ
      }
    }
    ems_state_v2 {
      ... on ConnextDataType {
        loggerId
        config {
          TZ
          configVerified
          connection
          error_id
          ext_device
          error_ts
          invCurrSensO
          invCurrSensTR
          io_cnt_func
          io_ing_used
          io_out_used
          latitude
          longitude
          maxLoadPwr
          mt_active
          mt_pb
          mt_sign
          net
          pType
          num_device
          pext
          plantCurrSensO
          plantCurrSensTR
          sensor_mode
          ta_sign
          tap_en
          tap_pb
          tas_en
          tas_pb
          timestamp
          virtualRTStatus {
            active
            startTS
            duration
            target
          }
        }
        devices {
          active
          arm
          cmd
          d2evc
          dModel
          dspm
          dsps
          fw_rev
          grid_meter
          id_list
          id
          k
          modbus_address
          model
          registered
          rgistered
          sensor_mode
          sn
          thingDef
          threeF
          timestamp
          type
          version
        }
        evch {
          active
          carConsumption
          chargerMode
          createdAt
          error_id
          dModel
          error_ts
          fwVer
          inputGreenPower
          limitPower
          maxpw
          model
          ready
          rsn
          rt_exp
          sn
          st_cmd
          wb_err_ts
          wb_err_id
          updatedAt
          type
          tpPower
          tpDuration
          timestamp
          tStart
          status
          startTime
        }
        info {
          cell_info {
            cell_model
            cell_revision
            cell_serial
            icc_id
            updatedAt
            imei
          }
          connection {
            disconnectReason
            ipAddress
            status
            timestamp
          }
          def {
            timestamp
            type
            thingDef
          }
          fw {
            updatedAt
            type
            timestamp
            fw_ver
            fwCategory
            fota_status
            createdAt
          }
          hwv {
            hwVer
            timestamp
          }
          name {
            timestamp
            name
          }
          sn {
            updatedAt
            uid
            type
            timestamp
            sn
            createdAt
          }
        }
        io {
          active
          d_start
          d_stop
          description
          function
          index
          level
          n_out
          name
          out_state
          out1
          state
          src
          t0_start
          t0_stop
          t1_start
          t1_stop
          t2_start
          t2_stop
          t3_start
          t3_stop
          t4_start
          t4_stop
          t5_start
          t5_stop
          t6_start
          t6_stop
          t_min
          templateId
          thH1
          thH
          thL
          thL1
          time_th
          time_th1
          var1
          time_tl1
          time_tl
        }
      }
      ... on AzzurroHubDataType {
        loggerId
        config {
          IANA
          actPwrCtrlAlgo
          operational
          scanDevices
          plantPhases
          monitoringMode
          plantDetectType
          maxPlantInvPwr
          maxContractualPwr
          evchTimeStop
          intSensorInversion
          evchTimeStart
          evchTimeModeEna
          evchPwrImportValue
          evchPwrImportLimit
          evchParallelEna
          evchCtrlEna
          evchBatterySOCLimit
          evchBatteryProtectEna
          evchStrategy
          country
          actPwrCtrlTarget
          actPwrCtrlEna
          virtualRTStatus {
            active
            startTS
            duration
            target
          }
        }
        info {
          upd {
            result

          }
          fw {
            shadowVer
            scriptVer
            hwVer
            dateProd
            currVer
            currBootSlot

            bootSts
            bootErr
          }
          connection {

            status
            ipAddress
            disconnectReason
          }
        }
        pwrMagic {
          updatedAt
          sn
          removed
          ipAddr
          deviceType
          createdAt
          connected
        }
        PSC100 {
          PBUSCCO1
          PBUSCCO2
          app
          connected
          core
          createdAt
          deviceType
          gcp
          inverters {
            sn
          }
          removed
          sdk
          sn
          updatedAt
        }
        meter {
          sn
          removed
          model
          modbusAdr
          deviceType

          connected
        }
        lan {
          wifi_strength
          wifi_status
          wifi_routerIP
          wifi_online
          wifi_ip
          wifi_enabled
          wifi_SSID
          wifi_DNS1
          wifi_DNS2
          wifi_DHCP
          eth_status
          eth_routerIP
          eth_online
          eth_ip
          eth_enabled
          eth_DNS2
          eth_DNS1
          eth_DHCP

        }
        inverter {
          sn
          safetyVer
          removed
          region
          modbusAdr
          hwVer
          dspm
          dsps
          deviceType
          country
          connected
          arm
          updating
          upd_arm { status progress }
          upd_dspm { status progress }
          upd_dsps { status progress }
          upd_safety { status progress }
          upd_sofar { status progress }
        }
        evChargerCAN {
          type

          swVer
          sts
          sn
          removed
          deviceType

          connected
          alerts
        }
        evCharger485 {

          swVer
          sts
          sn
          removed
          modbusAdr
          deviceType

          connected
          alerts
        }
        heatPump {
          DHWOn
          DHWSetTemp
          climOnA
          climOpMode
          climSetTempCoolingA
          updatedAt
          sn
          removed
          modbusAdr
          globStatus
          deviceType
          createdAt
          connected
          climSetTempHeatingA
        }
        solarSensor {
          deviceType
          sn
          connected
          removed
          updatedAt
          createdAt
        }
      }
    }
    ems {
      type
      sn
      installationTime
      disinstallationTime
    }
    config {
      meterInversion
      contractualPower
      phase
      monitoringType
    }
    plantPref {
      plantName
      monitorPref
      tagsDevices {
        key
        value
      }
    }
    devices {
      type
      sn
      installationTime
      disinstallationTime
    }
} `;
